import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";

import Login from "./Components/UserAuthentication/Login";
import Signup from "./Components/UserAuthentication/Signup";
import Logout from "./Components/UserAuthentication/Logout";
import ConfirmEmail from "./Components/UserAuthentication/ConfirmEmail";
import ConfirmationOverlay from "./Components/UserAuthentication/ConfirmationOverlay";
import ApproveUser from "./Components/UserAuthentication/ApproveUser";
import ProtectedRoute from "./Components/Dashboard/ProtectedRoute";
import Sidebar from "./Components/Dashboard/Sidebar/Sidebar";
import UserProfile from "./Components/Dashboard/UserDetails/UserProfile";
import DocAssistant from "./Components/Dashboard/DocAssistant/DocAssistant";
import Home from "./Components/Dashboard/Home/Home";
import ProductDashboard from "./Components/Dashboard/ProductDashboard/ProductDashboard";
import Dashboards_Image from "./assets/Dashboards_Image.png";

import { SeahorseProvider, DashBarWidgetContent } from "@seahorse/platform-ui";
import EmgptBuddyTile from "./GlobalLink/Geo-Political/Components/EmgptBuddy";
import CoTraderInsightsWidget from "./GlobalLink/Co-Trader/Widgets/CoTraderInsightsWidget";
import InfoFlowTile from "./GlobalLink/Geo-Political/Components/InfoFlow";
import ComboTile1 from "./GlobalLink/Geo-Political/Tiles/ComboTile1";
import GLProtectedRoute from "./GlobalLink/Wrapper/GLProtectedRoute";
import IntentListnerWrapper from "./GlobalLink/Wrapper/IntentListnerWrapper";
import DashbarIntentListnerWrapper from "./GlobalLink/Wrapper/DashbarIntentListnerWrapper";
import GLSSOLogin from "./GlobalLink/Wrapper/GLSSOLogin";
import ComboTile2 from "./GlobalLink/Geo-Political/Tiles/ComboTile2";
import ComboTile3 from "./GlobalLink/Geo-Political/Tiles/ComboTile3";
import ComboTile from "./GlobalLink/Geo-Political/Tiles/ComboTile";
import BestXTile1 from "./GlobalLink/Co-Trader/Tiles/BestXTile";
import TradeAnalysisTile from "./GlobalLink/Co-Trader/Tiles/TradeAnalysisTile";
import CoHedgerTile from "./GlobalLink/Co-Trader/Tiles/CoHedgerTile";

import CoTraderTile1 from "./GlobalLink/Co-Trader/Tiles/CoTraderTile1";
import PreTradeTile from "./GlobalLink/Co-Trader/Tiles/PreTradeTile";
import AboutEmalphaTile from "./GlobalLink/AboutEmalphaTile";
import CoTraderUserProfileTile from "./GlobalLink/CoTraderUserProfileTile";
import CoTraderInsightTile from "./GlobalLink/Co-Trader/Tiles/CoTraderInsightTile";
import CoTraderCurrencyChatTile from "./GlobalLink/Co-Trader/Tiles/CoTraderCurrencyChatTile";
import CoTraderPriceWidget from "./GlobalLink/Co-Trader/Widgets/CoTraderPriceWidget";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import GeoWidget from "./GlobalLink/Geo-Political/Widgets/GeoWidget";
import FaqTile from "./GlobalLink/FAQ";
import { useEffect, useState } from "react";
import { fetchCurrencyList } from "./GlobalLink/Co-Trader/Utils/CoTraderUtils";

function App() {
  const [context, setContext] = useState(null);
  const [interopEventId, setInteropEventId] = useState(0);
  const [dashbarContext, setDashbarContext] = useState(null);
  const interopEventKey = `interop-event-${interopEventId}`;
  const [tabs, setTabs] = useState([
    {
      name: "Home",
      subTabs: [],
      icon: "fas fa-home fa-lg",
      roles: ["USER", "ADMIN"],
      path: "/home",
      component: <Home />,
    },

    {
      name: "Report Reader",
      subTabs: [],
      icon: "fas fa-book-open-reader fa-xl",
      roles: ["USER", "ADMIN"],
      path: "/report-reader",
      component: <DocAssistant />,
    },
    {
      name: "Dashboard",
      subTabs: [],
      icon: "fa-chart-pie fa-xl",
      image: Dashboards_Image,
      path: "/dashboard",
      component: <ProductDashboard subTabs={[]} />,
    },
  ]);

  const [selectedTab, setSelectedTab] = useState();
  const [selectedSubTab, setSelectedSubTab] = useState("");
  const [currencyList, setCurrencyList] = useState(null);
  useEffect(() => {
    if (currencyList === null) {
      fetchCurrencyList(setCurrencyList);
    }
  });

  return (
    <Router>
      <div
        className="flex bg-custom "
        style={{ height: "100vh", width: "100vw" }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/confirm-email/:confirmationCode"
            element={<ConfirmEmail />}
          />
          <Route
            path="/approve-email/:approvalCode"
            element={<ApproveUser />}
          />
          <Route path="/confirm-email" element={<ConfirmationOverlay />} />
          {tabs.map((tab) => {
            return (
              <Route
                key={tab.name}
                path={tab.path}
                element={
                  <ProtectedRoute setTabs={setTabs} tabs={tabs}>
                    <div
                      className=" d-flex bg-custom"
                      style={{ height: "100vh" }}
                    >
                      <div>
                        <Sidebar
                          tabs={tabs}
                          setTabs={setTabs}
                          selectedTab={selectedTab}
                          selectedSubTab={selectedSubTab}
                          setSelectedTab={setSelectedTab}
                          setSelectedSubTab={setSelectedSubTab}
                        />
                      </div>
                      <div
                        className="flex-grow-1"
                        style={{ overflow: "auto", height: "100%" }}
                      >
                        {tab.component ? tab.component : null}
                      </div>
                    </div>
                  </ProtectedRoute>
                }
              />
            );
          })}
          <Route
            key="profile"
            path="/profile"
            element={
              <ProtectedRoute>
                <div className=" d-flex bg-custom" style={{ height: "100vh" }}>
                  <div>
                    <Sidebar
                      tabs={tabs}
                      setTabs={setTabs}
                      selectedTab={selectedTab}
                      selectedSubTab={selectedSubTab}
                      setSelectedTab={setSelectedTab}
                      setSelectedSubTab={setSelectedSubTab}
                    />
                  </div>
                  <div
                    className="flex-grow-1"
                    style={{ overflow: "auto", height: "100%" }}
                  >
                    <UserProfile />
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
          <Route path="/gl-sso-login/:loginToken" element={<GLSSOLogin />} />
          <Route
            path="/info_feed"
            element={
              <SeahorseProvider>
                <InfoFlowTile />
              </SeahorseProvider>
            }
          />
          <Route
            path="/geo"
            element={
              <SeahorseProvider>
                <DashBarWidgetContent size="large" platform="web">
                  <GeoWidget />
                </DashBarWidgetContent>
              </SeahorseProvider>
            }
          />
          <Route
            path="/global_link/geo_political_widget"
            element={
              <SeahorseProvider>
                <DashBarWidgetContent size="large" platform="web">
                  <EmgptBuddyTile />
                </DashBarWidgetContent>
              </SeahorseProvider>
            }
          />

          <Route
            path="/global_link/geo_political_tile_2"
            element={
              <SeahorseProvider>
                <GLProtectedRoute>
                  <ComboTile1 />
                </GLProtectedRoute>
              </SeahorseProvider>
            }
          />
          <Route
            path="/global_link/geo_political_tile_3"
            element={
              <SeahorseProvider>
                <GLProtectedRoute>
                  <ComboTile2 />
                </GLProtectedRoute>
              </SeahorseProvider>
            }
          />
          <Route
            path="/global_link/geo_political_tile_4"
            element={
              <SeahorseProvider>
                <GLProtectedRoute>
                  <ComboTile3 />
                </GLProtectedRoute>
              </SeahorseProvider>
            }
          />
          <Route
            path="/global_link/geo_political_tile_1"
            element={
              <SeahorseProvider>
                <GLProtectedRoute>
                  <ComboTile />
                </GLProtectedRoute>
              </SeahorseProvider>
            }
          />
          <Route
            path="/global_link/co_trader_tile_1"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <PreTradeTile
                        key={`${interopEventKey}-co-trader-tile-1`}
                        context={context}
                        currencyList={currencyList}
                        initialMarketTab="spot"
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/co_trader_tile_2"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <PreTradeTile
                        key={`${interopEventKey}-co-trader-tile-2`}
                        context={context}
                        currencyList={currencyList}
                        initialMarketTab="spot"
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/bestx_pre_trade"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <PreTradeTile
                        key={`${interopEventKey}-bestx-pre-trade`}
                        context={context}
                        currencyList={currencyList}
                        initialMarketTab="spot"
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
         <Route
  path="/global_link/best_x_tile_1"
  element={
    <ErrorBoundary>
      <SeahorseProvider>
        <GLProtectedRoute>
          <IntentListnerWrapper
            setContext={setContext}
            setInteropEventId={setInteropEventId}
          >
            <BestXTile1
              key={`${interopEventKey}-bestx-tile-1`}
              context={context}
              currencyList={currencyList}
            />
          </IntentListnerWrapper>
        </GLProtectedRoute>
      </SeahorseProvider>
    </ErrorBoundary>
  }
/>

          <Route
            path="/global_link/trade_analysis"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <TradeAnalysisTile
                        key={`${interopEventKey}-trade-analysis`}
                        context={context}
                        currencyList={currencyList}
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/co_hedger_tile_1"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <CoHedgerTile
                        key={`${interopEventKey}-co-hedger-tile-1`}
                        context={context}
                        currencyList={currencyList}
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/co_trader_currency_chat"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <CoTraderCurrencyChatTile
                        key={`${interopEventKey}-co-trader-currency-chat`}
                        context={context}
                        currencyList={currencyList}
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/co_trader_forward_tile_1"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <PreTradeTile
                        key={`${interopEventKey}-co-trader-forward-tile-1`}
                        context={context}
                        currencyList={currencyList}
                        initialMarketTab="forward"
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/co_trader_forward_tile_2"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <PreTradeTile
                        key={`${interopEventKey}-co-trader-forward-tile-2`}
                        context={context}
                        currencyList={currencyList}
                        initialMarketTab="forward"
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/co_trader_fx_forward_app"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <PreTradeTile
                        key={`${interopEventKey}-co-trader-fx-forward-app`}
                        context={context}
                        currencyList={currencyList}
                        initialMarketTab="forward"
                        showRealtimeSentiment
                        responsiveSideBySide
                      />
                      
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
           <Route
            path="/global_link/co_trader_fx_app"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                     <PreTradeTile
                        key={`${interopEventKey}-co-trader-fx-app`}
                        context={context}
                        currencyList={currencyList}
                        initialMarketTab="spot"
                        showRealtimeSentiment
                        showExecutionDecision
                        responsiveSideBySide
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/user_profile"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                     <CoTraderUserProfileTile
                        key={`${interopEventKey}-co-trader-user-profile`}
                        context={context}
                        currencyList={currencyList}
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/about_us"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <AboutEmalphaTile />
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
           <Route
            path="/global_link/faq"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <FaqTile />
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />

          <Route
            path="/global_link/co_trader_insights"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <GLProtectedRoute>
                    <IntentListnerWrapper
                      setContext={setContext}
                      setInteropEventId={setInteropEventId}
                    >
                      <CoTraderTile1
                        key={`${interopEventKey}-co-trader-tile-1`}
                        context={context}
                        currencyList={currencyList}
                      />
                    </IntentListnerWrapper>
                  </GLProtectedRoute>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/co_trader_insight_widget"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <DashbarIntentListnerWrapper
                    setDashbarContext={setDashbarContext}
                  >
                    <CoTraderInsightsWidget />
                  </DashbarIntentListnerWrapper>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />
          <Route
            path="/global_link/co_trader_price_widget"
            element={
              <ErrorBoundary>
                <SeahorseProvider>
                  <DashbarIntentListnerWrapper
                    setDashbarContext={setDashbarContext}
                  >
                    <CoTraderPriceWidget />
                  </DashbarIntentListnerWrapper>
                </SeahorseProvider>
              </ErrorBoundary>
            }
          />

          <Route path="/*" element={<Login />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
